import DefaultProposalPriceBeforeAdjustmentCalculator from "./DefaultProposalPriceBeforeAdjustmentCalculator";

export default class DefaultProposalPriceBeforeAdjustmentCalculatorFactory {
    private static readonly INSTANCE = new DefaultProposalPriceBeforeAdjustmentCalculator();
    public static getInstance() {
        return this.INSTANCE;
    }
}
